/// <amd-module name="Artifacts/PackageRecycleBin/redux/Actions" />
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { IDeletedPackageVersion } from "Artifacts/PackageRecycleBin/types";
import { ILoadFailedPayload } from "Artifacts/Root/Redux";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import {
  ActionsUnion,
  createAction,
  trackedAction,
  trackedErrorAction,
} from "redux/Utils/ActionHelper";

export const enum PackageRecycleBinActionTypes {
  // Data Retrieval Actions
  InitLoad = "Artifacts/PackageRecycleBinHub/InitLoad",
  InitLoadStarted = "Artifacts/PackageRecycleBinHub/InitLoadStarted",
  InitLoadCompleted = "Artifacts/PackageRecycleBinHub/InitLoadCompleted",
  InitLoadFailed = "Artifacts/PackageRecycleBinHub/InitLoadFailed",

  // Recycle Bin Actions
  EmptyRecycleBin = "Artifacts/PackageRecycleBinHub/EmptyRecycleBin",
  FakeEmptyOnClient = "Artifacts/PackageRecycleBinHub/FakeEmpty",
  FakePackagePermanentDelete = "Artifacts/PackageRecycleBinHub/FakePackagePermanentDelete",
  FakePackageRestore = "Artifacts/PackageRecycleBinHub/FakePackageRestore",

  // API Actions
  EmptyRecycleBinStarted = "#api/Artifacts/PackageRecycleBinHub/EmptyRecycleBinStarted",
  EmptyRecycleBinCompleted = "#api/Artifacts/PackageRecycleBinHub/EmptyRecycleBinCompleted",
  EmptyRecycleBinFailed = "#api/Artifacts/PackageRecycleBinHub/EmptyRecycleBinFailed",
}

export interface IInitLoadPayload {
  feed: IFeed;
}

export interface IInitLoadCompletedPayload {
  pkgVersions: IDeletedPackageVersion[];
}

export interface IEmptyRecycleBinCompletedPayload {
  // result of empty recycle bin call
  resultMessage: string;
}

export interface IEmptyRecycleBinPayload {
  feed: IFeed;
  onSuccessCallback: () => void;
}

export interface ISelectedDeletedPackagesPayload {
  selectedVersions: IPackageVersionIdentity[];
}

export const PackageRecycleBinActions = {
  initLoad: (feed: IFeed) =>
    createAction<PackageRecycleBinActionTypes, IInitLoadPayload>(
      PackageRecycleBinActionTypes.InitLoad,
      {
        feed,
      },
    ),
  loadStarted: () => createAction(PackageRecycleBinActionTypes.InitLoadStarted),
  loadCompleted: (pkgVersions: IDeletedPackageVersion[]) =>
    createAction<PackageRecycleBinActionTypes, IInitLoadCompletedPayload>(
      PackageRecycleBinActionTypes.InitLoadCompleted,
      {
        pkgVersions,
      },
    ),
  loadFailed: (error: string) =>
    createAction<PackageRecycleBinActionTypes, ILoadFailedPayload>(
      PackageRecycleBinActionTypes.InitLoadFailed,
      {
        error,
      },
    ),
  emptyRecycleBin: (feed: IFeed, onSuccessCallback: () => void) =>
    trackedAction(
      createAction<PackageRecycleBinActionTypes, IEmptyRecycleBinPayload>(
        PackageRecycleBinActionTypes.EmptyRecycleBin,
        { feed, onSuccessCallback },
      ),
    ),
  emptyRecycleBinStarted: () => createAction(PackageRecycleBinActionTypes.EmptyRecycleBinStarted),
  emptyRecycleBinCompleted: (resultMessage: string) =>
    trackedAction(
      createAction<PackageRecycleBinActionTypes, IEmptyRecycleBinCompletedPayload>(
        PackageRecycleBinActionTypes.EmptyRecycleBinCompleted,
        { resultMessage },
      ),
    ),
  emptyRecycleBinFailed: (error: string) =>
    trackedErrorAction(
      createAction<PackageRecycleBinActionTypes, ILoadFailedPayload>(
        PackageRecycleBinActionTypes.EmptyRecycleBinFailed,
        { error },
      ),
    ),
  fakeEmptyOnClient: () => createAction(PackageRecycleBinActionTypes.FakeEmptyOnClient),
  fakePackagePermanentDelete: (selectedVersions: IPackageVersionIdentity[]) =>
    createAction<PackageRecycleBinActionTypes, ISelectedDeletedPackagesPayload>(
      PackageRecycleBinActionTypes.FakePackagePermanentDelete,
      {
        selectedVersions,
      },
    ),
  fakePackageRestore: (selectedVersions: IPackageVersionIdentity[]) =>
    createAction<PackageRecycleBinActionTypes, ISelectedDeletedPackagesPayload>(
      PackageRecycleBinActionTypes.FakePackageRestore,
      {
        selectedVersions,
      },
    ),
};

export type PackageRecycleBinActionsUnion = ActionsUnion<typeof PackageRecycleBinActions>;
